import { Outlet, useNavigate } from 'react-router-dom';
import { getPortalUser, portalLogout } from '../services/portalAuth';
import { portalApi } from '../services/portalApi';
import './PortalShell.css';

export default function PortalShell() {
  const navigate = useNavigate();
  const user = getPortalUser();

  async function handleLogout() {
    try {
      await portalApi.logout();
    } catch {
      // Server-side cookie clear failed (network error). Warn the user so they
      // know the session may still be active on a shared machine.
      window.alert('Sign-out failed. Close this browser window to end your session.');
      return;
    }
    portalLogout();
    navigate('/portal/login', { replace: true });
  }

  return (
    <div className="portal-layout">
      <header className="portal-header">
        <div className="portal-header-inner">
          <div className="portal-brand">
            <span className="portal-brand-main">Semper Gratus</span>
            <span className="portal-brand-tag">Client Portal</span>
          </div>
          <div className="portal-header-right">
            {user?.name && <span className="portal-user-name">{user.name}</span>}
            <button className="portal-logout-btn" onClick={handleLogout}>Sign out</button>
          </div>
        </div>
      </header>
      <main className="portal-main">
        <Outlet />
      </main>
      <footer className="portal-footer">
        <p>© {new Date().getFullYear()} Semper Gratus Inc. · <a href="mailto:hello@sempergratusinc.com">hello@sempergratusinc.com</a></p>
      </footer>
    </div>
  );
}
